export default __webpack_public_path__ + "static/media/grafema_SET_20.89332ef4.jpg";